<template><div><h1>VUX V2.2.0 发布日志</h1>
<h2><a href="/zh-CN/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[enhance] 在使用 v-transfer-dom 的情况下不再处理 Safari 下的 z-index 问题</li>
</ul>
<h2><a href="/zh-CN/components/alert.html">Alert</a></h2>
<ul><li>[feature] 添加属性 prop:content</li>
</ul>
<h2><a href="/zh-CN/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[enhance] 更新 1px 边框</li>
</ul>
<h2><a href="/zh-CN/components/cell-form-preview.html">CellFormPreview</a></h2>
<ul><li>[feature] 新组件</li>
</ul>
<h2><a href="/zh-CN/components/cell.html">Cell</a></h2>
<ul><li>[feature] 支持 prop:is-loading 显示加载图标，适用于异步加载数据的场景</li>
</ul>
<h2><a href="/zh-CN/components/datetime-range.html">DatetimeRange</a></h2>
<ul><li>[enhance] 优化宽度，避免日期栏和左边缘距离过近</li>
</ul>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] 在 nextTick 回调渲染 picker 避免赋值报错 #1180</li>
</ul>
<h2><a href="/zh-CN/components/grid.html">Grid</a></h2>
<ul><li>[feature] 支持定义列数</li>
<li>[enhance] 如果没有使用 icon 和 label，则直接隐藏 slot:icon 和 slot:label</li>
</ul>
<h2><a href="/zh-CN/components/scroller.html">Scroller</a></h2>
<ul><li>[fix] 修复 resize 事件没有移除导致切换页面报错 #1183</li>
<li>[fix] 修复滚动情况下跳转页面报错 #1187</li>
</ul>
<h2><a href="/zh-CN/components/search.html">Search</a></h2>
<ul><li>[enhance] 在 input 后触发 on-change 事件(否则此时 v-model 绑定的值和参数不一致)</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] 修复disabled时不能上下滚动问题</li>
<li>[fix] 修复disabled时，安卓手机上不能触发点击事件的问题</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[enhance] 更新地区数据 #1101</li>
</ul>
<h2><a href="/zh-CN/components/x-icon.html">XIcon</a></h2>
<ul><li>[enhance] 支持传任意属性 #1147</li>
</ul>
<h2><a href="/zh-CN/components/transfer-dom.html">TransferDom</a></h2>
<ul><li>[enhance] 支持更简洁的引入方式：TransferDom</li>
<li>[enhance] 添加类名 v-transfer-dom</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.0 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.0-218.vue?ef2a63a8